import * as React from 'react';

// Hooks
import { useResponsiveLayout, Layout } from '@shopee-user/layout-responsive';

// Components
import ResponsiveImage from '../ResponsiveImage';
// Assets
import backgroundMdpi from './assets/background-1x.png';
import backgroundHdpi from './assets/background-1.5x.png';
import backgroundXhdpi from './assets/background-2x.png';
import backgroundXxhdpi from './assets/background-3x.png';
import backgroundXxxhdpi from './assets/background-4x.png';

import desktopBackgroundMdpi from './assets/desktopBackground-1x.png';
import desktopBackgroundHdpi from './assets/desktopBackground-1.5x.png';
import desktopBackgroundXhdpi from './assets/desktopBackground-2x.png';
import desktopBackgroundXxhdpi from './assets/desktopBackground-3x.png';
import desktopBackgroundXxxhdpi from './assets/desktopBackground-4x.png';

type Props = { className?: string };

function OneCredentialMigrateOverviewBackgroundImage({ className }: Props) {
  const { layout } = useResponsiveLayout();

  return (
    <ResponsiveImage
      className={className}
      defaultSrc={
        layout === Layout.Desktop ? desktopBackgroundMdpi : backgroundMdpi
      }
      srcSet={
        layout === Layout.Desktop
          ? [
              `${desktopBackgroundMdpi} 1x`,
              `${desktopBackgroundHdpi} 1.5x`,
              `${desktopBackgroundXhdpi} 2x`,
              `${desktopBackgroundXxhdpi} 3x`,
              `${desktopBackgroundXxxhdpi} 4x`,
            ].join(',')
          : [
              `${backgroundMdpi} 1x`,
              `${backgroundHdpi} 1.5x`,
              `${backgroundXhdpi} 2x`,
              `${backgroundXxhdpi} 3x`,
              `${backgroundXxxhdpi} 4x`,
            ].join(',')
      }
    />
  );
}

export default OneCredentialMigrateOverviewBackgroundImage;
